import { PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { CreateClientAdminUserForm } from '~/features/CreateClientAdminUserForm';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[
          { label: '企業管理者', href: ROUTES.ADMINS.INDEX },
          { label: '新規追加' },
        ]}
      />
      <main className={styles.body}>
        <Suspense fallback={<Shimmer />}>
          <CreateClientAdminUserForm />
        </Suspense>
      </main>
    </div>
  </div>
);
